import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, forkJoin, Observable, combineLatest, map, tap } from 'rxjs';
import { ValueList_create, ValueList_update, ValueList_delete, ValueList_readById, ValueList_readAll, ValueList_ReadKeyValueDictionaryByCode, ValueListItem_create, ValueListItem_update, ValueListItem_delete, ValueListItem_readById, ValueListItem_readByValueListId, ValueListItem_readByVlCode, ValueListItem_readByVlCodeList, ValueListItem_readByCompanyId, ValueList_GetFilteredKeyValueDictionaryByCode } from 'src/app/GlobalVariable';
import { UserLoginService } from 'src/app/login/userlogin.service';
import { ValueListItemDTO, ValueListItemCreateRequestDTO, ValueListItemUpdateRequestDTO, ValueListItemDeleteRequestDTO, ValueListItemReadByIdRequestDTO, ValueListItemReadByValueListIdRequestDTO, ValueListItemList, ValueListItemReadByVlCodeRequestDTO, ValueListItemReadByVlCodeListRequestDTO, ValueListItemReadByCompanyId } from './value-list-item.interface';
import { ValueListDTO, ValueListCreateRequestDTO, ValueListUpdateRequestDTO, ValueListDeleteRequestDTO, ValueListReadByIdRequestDTO, ValueListList, KeyValueRequestDTO, KeyValueDictionaryList, FilteredKeyValueRequestDTO } from './value-list.interface';

@Injectable({
  providedIn: 'root'
})
export class ValueListService {

  constructor() { }

  http = inject(HttpClient);
  ValueList$ = new BehaviorSubject<ValueListDTO[]>([]);
  ValueListItems$ = new BehaviorSubject<ValueListItemDTO[]>([]);



  User = inject(UserLoginService).User()

  FetchAllValueLists() {
    forkJoin({
      valueList: this.ValueList_readAll(),
      valueListItems: this.ValueListItem_readByCompanyId({ companyId: this.User.companyId })
    }).subscribe(({ valueList, valueListItems }) => {
      this.ValueList$.next(valueList.items)
      this.ValueListItems$.next(valueListItems.items)
    });
  }

  getItemByVLCode(vlCode: string): Observable<ValueListItemDTO[]> {
    return combineLatest([this.ValueList$, this.ValueListItems$]).pipe(
      map(([valueLists, valueListItems]) => {
        const valuelist = valueLists.find(i => i.vlCode === vlCode);
        return valueListItems.filter(f => f.valueListId === valuelist?.valueListId);
      })
    );
  }





  ValueList_create(data: ValueListCreateRequestDTO): Observable<ValueListDTO> {
    return this.http.post<ValueListDTO>(ValueList_create, data).pipe(tap((newValueList: ValueListDTO) => {
      const current = this.ValueList$.getValue();
      this.ValueList$.next([...current, newValueList]);
    }))
  }
  ValueList_update(data: ValueListUpdateRequestDTO): Observable<ValueListDTO> {
    return this.http.post<ValueListDTO>(ValueList_update, data).pipe(tap((updatedValueList: ValueListDTO) => {
      const current = this.ValueList$.getValue();
      const updatedList = current.map(item =>
        item.valueListId === updatedValueList.valueListId ? updatedValueList : item
      );
      this.ValueList$.next(updatedList);
    }))
  }
  ValueList_delete(data: ValueListDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(ValueList_delete, data).pipe(
      tap(() => {
        const current = this.ValueList$.getValue();
        const updatedList = current.filter(item => item.valueListId !== data.valueListId);
        this.ValueList$.next(updatedList);
      })
    );
  }
  ValueList_readById(data: ValueListReadByIdRequestDTO): Observable<ValueListDTO> {
    return this.http.post<ValueListDTO>(ValueList_readById, data)
  }
  ValueList_readAll(): Observable<ValueListList> {
    return this.http.get<ValueListList>(ValueList_readAll)
  }

  ValueList_readKeyValueDictionaryByCode(data: KeyValueRequestDTO): Observable<KeyValueDictionaryList> {
    return this.http.post<KeyValueDictionaryList>(ValueList_ReadKeyValueDictionaryByCode, data)
  }





  ValueListItem_create(data: ValueListItemCreateRequestDTO): Observable<ValueListItemDTO> {
    return this.http.post<ValueListItemDTO>(ValueListItem_create, data).pipe(tap((newValueListItem: ValueListItemDTO) => {
      const current = this.ValueListItems$.getValue();
      this.ValueListItems$.next([...current, newValueListItem]);
    }))
  }


  ValueListItem_update(data: ValueListItemUpdateRequestDTO): Observable<ValueListItemDTO> {
    return this.http.post<ValueListItemDTO>(ValueListItem_update, data).pipe(tap((updatedValueListItem: ValueListItemDTO) => {
      const current = this.ValueListItems$.getValue();
      const updatedList = current.map(item =>
        item.valueListItemId === updatedValueListItem.valueListItemId ? updatedValueListItem : item
      );
      this.ValueListItems$.next(updatedList);
    }))
  }

  ValueListItem_delete(data: ValueListItemDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(ValueListItem_delete, data).pipe(tap(() => {
      const current = this.ValueListItems$.getValue();
      const updatedList = current.filter(item => item.valueListItemId !== data.valueListItemId);
      this.ValueListItems$.next(updatedList);
    }))
  }

  ValueListItem_readById(data: ValueListItemReadByIdRequestDTO): Observable<ValueListItemDTO> {
    return this.http.post<ValueListItemDTO>(ValueListItem_readById, data)
  }

  ValueListItem_readByValueListId(data: ValueListItemReadByValueListIdRequestDTO): Observable<ValueListItemList> {
    return this.http.post<ValueListItemList>(ValueListItem_readByValueListId, data)
  }

  ValueListItem_readByVlCode(data: ValueListItemReadByVlCodeRequestDTO): Observable<ValueListItemList> {
    return this.http.post<ValueListItemList>(ValueListItem_readByVlCode, data)
  }

  ValueListItem_readByVlCodeListId(data: ValueListItemReadByVlCodeListRequestDTO): Observable<ValueListItemList> {
    return this.http.post<ValueListItemList>(ValueListItem_readByVlCodeList, data)
  }

  ValueListItem_readByCompanyId(data: ValueListItemReadByCompanyId): Observable<ValueListItemList> {
    return this.http.post<ValueListItemList>(ValueListItem_readByCompanyId, data)
  }

  ValueListItem_ReadKeyValueDictionaryByCode(data: KeyValueRequestDTO): Observable<KeyValueDictionaryList> {
    return this.http.post<KeyValueDictionaryList>(ValueList_ReadKeyValueDictionaryByCode, data)
  }

  ValueListItem_GetFilteredKeyValueDictionaryByCode(data: FilteredKeyValueRequestDTO): Observable<KeyValueDictionaryList> {
    return this.http.post<KeyValueDictionaryList>(ValueList_GetFilteredKeyValueDictionaryByCode, data)
  }
}
